import passwordUnlock from "../lib/header/password-unlock";
import { qs, qsa, toggle } from "@fluorescent/dom";
import { emit } from "@/glow/events";

import { section } from "@/glow";
import { provideResizeObserver } from "@/utils";
import { activateTemplate } from "@/lib/templates";

function setHeaderHeightVar(height) {
  document.documentElement.style.setProperty(
    "--height-header",
    `${Math.ceil(height)}px`
  );
}

function setHeaderStickyHeaderHeight(value) {
  document.documentElement.style.setProperty(
    "--header-desktop-sticky-height",
    `${value}px`
  );
}

const selectors = {
  headerSpace: "[data-header-space]",
  navigation: "[data-navigation]",
  navigationBar: "[data-navigation-bar]",
  navBarButton: "[data-nav-bar-button]",
};

const classes = {
  headerTransparent: "header-transparent",
  stickyEnabled: "sticky-header-enabled",
  stickyActive: "sticky-header-active",
  hideNavBar: "nav-bar-hidden",
  navBarToggleVisible: "nav-bar-toggle-visible",
  isSticky: "is-sticky",
  active: "active",
};

section("password-header", {
  crossBorder: {},

  onLoad() {
    const { enableStickyHeader, transparentHeader } = this.container.dataset;
    const headerSpace = qs(selectors.headerSpace, document);
    const navBar = qs(selectors.navigationBar, document);
    const navBarToggle = qs(selectors.navBarButton, this.container);

    if (window.Shopify.designMode) {
      // In the theme editor we want the templates activated up front
      qsa("template", this.container).forEach(templateEl => {
        activateTemplate(templateEl.getAttribute("data-template-key"));
      });
    }

    // This is done here AND in the liquid so it is responsive in TE but doesn't wait for JS otherwise
    document.body.classList.toggle(
      classes.headerTransparent,
      Boolean(transparentHeader)
    );
    document.documentElement.classList.toggle(
      classes.stickyEnabled,
      Boolean(enableStickyHeader)
    );

    if (enableStickyHeader) {
      // Our header is always sticky (with position: sticky) however at some
      // point we want to adjust the styling (eg. box-shadow) so we toggle
      // the is-sticky class when our arbitrary space element (.header__space)
      // goes in and out of the viewport.
      this.io = new IntersectionObserver(([{ isIntersecting: visible }]) => {
        toggle(this.container, classes.isSticky, !visible);
        toggle(document.documentElement, classes.stickyActive, !visible);

        // Our navBar (only visible in some layouts) needs to animate: hide / show
        // after we have scrolled down the page enough that the changing of the height
        // will not mess with the above observer.
        if (navBar) {
          toggle(document.documentElement, classes.hideNavBar, !visible);
          toggle(
            document.documentElement,
            classes.navBarToggleVisible,
            !visible
          );

          if (visible) {
            navBarToggle.setAttribute("aria-expanded", false);
          }

          emit("navBar:change");
        }
      });
      this.io.observe(headerSpace);
    }

    // This will watch the height of the header and update the --height-header
    // css variable when necessary. That var gets used for the negative top margin
    // to render the page body under the transparent header
    provideResizeObserver().then(({ ResizeObserver }) => {
      this.ro = new ResizeObserver(([{ target }]) => {
        const headerHeight = target.offsetHeight;

        setHeaderHeightVar(
          target.getBoundingClientRect()
            ? target.getBoundingClientRect().height
            : target.offsetHeight
        );
        setHeaderStickyHeaderHeight(headerHeight);
      });
      this.ro.observe(this.container);
    });

    this.passwordUnlock = passwordUnlock(this.container);
  },

  onUnload() {
    this.passwordUnlock;
    this.io && this.io.disconnect();
    this.ro.disconnect();
  },
});
